
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/[...procedureslug]",
      function () {
        return require("private-next-pages/d/[...procedureslug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/[...procedureslug]"])
      });
    }
  